module.exports = __webpack_public_path__ + "static/media/nexus-icon.a9abcdff.png";